import React from 'react';
import InputGroup from '../InputGroup';
import InputFormat from 'components/InputFormat';
import moment from 'moment';

const getErrorMessage = (isRequired, value, onlyYear) => {
  debugger
  if (!value && isRequired) return 'O campo é obrigatório';
  if (value) return moment(value, onlyYear ? 'YYYY' : 'MM/YYYY', true).isValid();
  return 'Informação inválida';
}

const YearMonthPicker = ({ 
  value, 
  onChange, 
  label, 
  disabled, 
  error, 
  isRequired, 
  onlyYear = false
}) => {
  const getDisplayValue = () => {
    if (!value) return '';

    const format = onlyYear ? "YYYY" : "MM/YYYY";

    if (typeof value === 'number') {
      const date = moment(value);
      if (date.isValid) {
        return date.format(format);
      } 
    } 
    
    const date = moment(value, format, true);
    if (date.isValid()) {
      return date.format(format);
    }

    return value;
  };

  const handleInputChange = (event) => {
    const { value: rawValue } = event.target;
    const digits = rawValue.replace(/\D/g, '');

    if (!onlyYear && digits.length > 0) {
      const firstDigit = parseInt(digits[0], 10);
      
      if (firstDigit > 1) {
        onChange("");
        return;
      }

      if (digits.length === 2 && firstDigit === 1) {
        const secondDigit = parseInt(digits[1], 10);
        if (secondDigit > 2) {
          onChange(digits[0]);
          return;
        } 
      }
      
      if (digits.length === 2 && firstDigit === 0) {
        const secondDigit = parseInt(digits[1], 10);
        if (secondDigit === 0) {
          onChange(digits[0]);
          return;
        }
      }
    }

    const format = onlyYear ? "YYYY" : "MM/YYYY";
    if (digits.length === (onlyYear ? 4 : 6)) {
      const parsed = moment(rawValue, format, true);
      if (parsed.isValid()) {
        onChange(parsed.valueOf());
      }
    } else {
      onChange(rawValue);
    }
  };

  return (
    <InputGroup label={label} isRequired={isRequired}>
      <InputFormat
        label={label}
        value={getDisplayValue()}
        onChange={handleInputChange}
        disabled={disabled}
        error={!!error}
        helperText={error ? getErrorMessage(isRequired, value, onlyYear): ''}
        format={onlyYear ? "####" : "##/####"}
        mask="_"
        showInputGroup={false}
      />
    </InputGroup>
  );
};

export default YearMonthPicker;